import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faMapMarkerAlt, faSearch, faEdit, faFileAlt, faQrcode, faSave, faFileSignature, faFile, faEye } from '@fortawesome/free-solid-svg-icons';
import html2canvas from 'html2canvas';
import { Row, Col, Button } from 'reactstrap';
import { QRCode } from "react-qrcode-logo";
import moment from 'moment/moment';

//Assets
import logoImg from '../../../../assets/img/logoQrCode.png';

//Components
import TabelaContratos from './TabelaContratos';
import Loading from '../../../../components/Loading/Loading';
import TabelaEnderecos from './TabelaEnderecos';
import ModalCustomized from '../../../../components/Modal/Modal';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TabelaInscricoesMunicipais from './TabelaInscricoesMunicipais';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import { abrirPDF } from '../../../../helpers/abrirPDF';

//API
import { showMessage } from 'helpers/message';
import prefeitura_api from '../../../../api/prefeitura_api';

//Context
import { useAuth } from '../../../../context/auth';
import gerador_api from 'api/gerador_api';
import usuario_api from 'api/usuario_api';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';

export default function FichaGeradorContainer({ gerador = {}, editGerador = null, editEnderecos = null, editContratos, modulo, setVistoria, integracaoCadastros, cadastroExternoGerador = false }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado para pegar fundo QrCode
    const [imagens, setImagens] = useState(null);

    const { session, setupVariavel } = useAuth();

    //Headers das vistorias
    const headersVistorias = [
        { value: "Formulario", objectValue: "formulario" },
        { value: "Data", objectValue: "dataAgendamento" },
        { value: "Enquadramento", objectValue: "enquadramento" },
        { value: "Fiscal", objectValue: "fiscal" }
    ];

    //Estado de controle de visualização do qrcode do contrato do gerador
    const [openModalQrCode, setOpenModalQrCode] = useState(false);
    const toggleModalQr = () => {
        setOpenModalQrCode(!openModalQrCode);
        if (openModalQrCode) {
            setContrato({});
            setLocalidade({});
        }
    };

    //Estado de controle dos dados da ficha do gerador
    const geradorFicha = { ...gerador };

    //Estado de controle dos dados do contrato selecionado
    const [contrato, setContrato] = useState({});

    //Estado de controle da localidade selecionada
    const [localidade, setLocalidade] = useState({});

    //Gerando novos objetos de contratos para que nenhuma alteração interfira nos dados
    geradorFicha.localidades = geradorFicha.localidades.map(value => {
        if (value.contratos) {
            value.contratos = value.contratos.map(value => {
                return { ...value };
            });
        }
        return { ...value };
    })

    const loadFundoQrCode = () => {
        setLoading(true);
        prefeitura_api.GetImagensQrcode(gerador.tbPrefeituras_id)
            .then(response => {
                setImagens(response.data);
            })
            .catch(err => showMessage("Error", err.message, "error", null))
            .finally(() => setLoading(false))
    }

    useEffect(() => {

        if (gerador?.tbPrefeituras_id)
            loadFundoQrCode();
    }, []);

    //Função executada ao clicar no qrCode
    const onClickQrCode = (contrato, localidade) => {
        setContrato(contrato);
        setLocalidade(localidade);
        toggleModalQr();
    }

    //Função que faz a exportação como imagem do qrcode
    const exportAsImage = async (imageFileName) => {
        const element = document.getElementById("containerDownload")
        const canvas = await html2canvas(element);
        const image = canvas.toDataURL("image/png", 1.0);
        downloadImage(image, imageFileName);
    };

    //Função para fazer o download do qrcode
    const downloadImage = (blob, fileName) => {
        const fakeLink = window.document.createElement("a");
        fakeLink.style = "display:none;";
        fakeLink.download = fileName;

        fakeLink.href = blob;

        document.body.appendChild(fakeLink);
        fakeLink.click();
        document.body.removeChild(fakeLink);

        fakeLink.remove();
    };

    const [visualizarModalAnalise, setVisualizarModalAnalise] = useState(0)
    const [fichaAnaliseLocalidade, setFichaAnaliseLocalidade] = useState()
    //Cabeçalhos da tabela de listagem de ações 
    const headersTabela = [
        { value: "Data/Hora", objectValue: "dataHora", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Observações", objectValue: "observacoes", align: "left" },
    ];

    //Controle de exibição do modal de recusa na tela
    const toggleModalFichaAnalise = () => {
        setVisualizarModalAnalise(!visualizarModalAnalise);
    };

    // Função para exibir o modal do histórico de análises da localidade
    const visualizarAnaliseLocalidade = (localidade_Id) => {
        setVisualizarModalAnalise(true);
        setLoading(true);
    
        gerador_api.GetAnaliseLocalidade(localidade_Id)
            .then(response => {
                return Promise.all(response.data.map(async m => {
                    const nomeUsuario = await usuario_api.getItem(m.tbUsuarios_Id).then(retorno => retorno.data.nome);
                    return {
                        ...m,
                        dataHora: moment(m.dataHora).format("DD/MM/YYYY HH:mm:ss"),
                        nomeUsuario: nomeUsuario
                    };
                }));
            })
            .then(dataFormatada => {
                setFichaAnaliseLocalidade(dataFormatada);
            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(() => setLoading(false));
    };


    return (
        <div style={{ color: "#666" }}>
            <div>
                {loading && <Loading />}
                <ModalCustomized
                    isOpen={openModalQrCode}
                    toggle={toggleModalQr}
                    btnClose={toggleModalQr}
                >
                    <div className='mb-2'>
                        <div className='d-flex align-items-center justify-content-center flex-column' id={"containerDownload"}>
                            {!!imagens?.logotipoSecretaria &&
                                <img src={"data:image/png;base64," + imagens.logotipoSecretaria} alt="imagem da logo" style={{ width: 300 }} />
                            }
                            <div className={`p-3 d-flex align-items-center justify-content-center flex-column ${imagens ? "bg-success bg-gradient rounded" : ""}`}>
                                <div className={`${imagens ? "p-3 bg-white rounded" : ""}`}>
                                    <QRCode
                                        value={contrato?.tag}
                                        enableCORS={true}
                                        logoImage={logoImg}
                                        size="300"
                                        logoOpacity={1}
                                        qrStyle={"squares"}
                                        fgColor={"#000"}
                                        bgColor={"#fff"}
                                        logoWidth={60}
                                        logoheight={60}
                                    />
                                </div>
                                <h5 className={`mt-2 ${imagens ? "text-white" : ""} `}>{contrato.modalidade}</h5>
                                <p className={` ${imagens ? "text-white" : ""} `}><span className="fw-bold">Gerador: </span> {localidade.identificacao}</p>
                                <p className={` ${imagens ? "text-white" : ""} `}><span className="fw-bold">Transportador: </span> {contrato.nomeFantasiaTransportador}</p>
                            </div>
                            {!!imagens?.logotipoQRCode &&
                                <img src={"data:image/png;base64," + imagens.logotipoQRCode} alt="imagem da logo" style={{ width: 300 }} />
                            }
                            <p className='mt-1'><span className="fw-bold">Endereço: </span> {localidade.logradouro}, {localidade.numero}, {localidade.bairro}{localidade.complemento ? ` - ${localidade.complemento}` : ""},{localidade.cidade} - {localidade.uf}</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                        <Button onClick={() => exportAsImage("qrCode.png")} color={"success"} ><FontAwesomeIcon icon={faSave} /> Download</Button>
                    </div>
                </ModalCustomized>

                <ModalCustomized 
                    title={"Ficha Análise Localidade"} 
                    isOpen={visualizarModalAnalise} 
                    toggle={toggleModalFichaAnalise} 
                    btnActionColor={"success"} btnClose
                >
                    <TabelaListagem
                        title="Histórico"
                        headers={headersTabela}
                        items={fichaAnaliseLocalidade}
                        options={{
                            print: false,
                            search: false,
                            pagination: false
                        }}
                    />
                </ModalCustomized>
                <h5 className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center' style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Identificação do gerador</span>{editGerador && <button onClick={editGerador} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }} color='info'><FontAwesomeIcon icon={faEdit} /></button>} </h5>
                <Row>

                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Fantasia: </span> {geradorFicha.fantasia}</p>
                    </Col>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Razão social: </span> {geradorFicha.razao}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">CPF / CNPJ: </span> {mascaras.cpfcnpjMask(geradorFicha.cpfcnpj)}</p>
                    </Col>
                    {!!gerador?.codigoCadastro &&
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Código Cadastro: </span> {gerador.codigoCadastro}</p>
                        </Col>
                    }

                    <Col md="12" lg={4}>
                        <p><span className="fw-bold">Email: </span> {!geradorFicha.email ? "Não informado" : geradorFicha.email}</p>
                    </Col>
                    <Col md="12" lg={!!gerador?.codigoCadastro ? 12 : 4}>
                        <p><span className="fw-bold">Responsavel: </span> {!geradorFicha.contato ? "Não informado" : geradorFicha.contato}</p>
                    </Col>
                </Row>
                <Row>

                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Fone: </span> {!geradorFicha.fone ? "Não informado" : mascaras.celularMask(geradorFicha.fone)}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Celular: </span> {geradorFicha.celular && geradorFicha.celular.length > 0 ? geradorFicha.celular : "Não informado"}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Categoria: </span> {geradorFicha.categoria}</p>
                    </Col>

                </Row>
                <Row>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Status: </span> <span className={geradorFicha.status === "Inativo" ? "text-danger fw-bold" : "text-success fw-bold"}>{geradorFicha.status}</span></p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Característica: </span> {geradorFicha.caracteristica}</p>
                    </Col>
                    <Col md="12" lg="4">
                        <p><span className="fw-bold">Ramo de atividade: </span> {geradorFicha.tbSegmentos_Descricao}</p>
                    </Col>
                    {geradorFicha.cnaes?.length > 0 &&
                        <Col md="12" lg="8">
                            <p><span className="fw-bold">CNAE: </span> {geradorFicha.cnaes.map(c => c.codigo + (c.principal ? " (Principal)" : "")).join(", ")}</p>
                        </Col>
                    }
                    {geradorFicha.dataValidade &&
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Data Validade: </span> {moment(geradorFicha.dataValidade).format("DD/MM/YYYY")}</p>
                        </Col>
                    }
                    {geradorFicha?.dataHoraCadastro &&
                        <Col md="12" lg="4">
                            <p><span className="fw-bold">Data/Hora Solicitação Cadastro: </span> {moment(geradorFicha?.dataHoraCadastro).format("DD/MM/YYYY HH:mm:ss")}</p>
                        </Col>
                    }
                </Row>
            </div>
            <div>
                <h5 style={{ color: "#fff" }} className='p-2 rounded-3 bg-gradient bg-primary fw-normal d-flex justify-content-between align-items-center'> <span><FontAwesomeIcon icon={faMapMarkerAlt} className={"me-3"} />Endereços</span>{editEnderecos && <button onClick={editEnderecos} style={{ backgroundColor: "transparent", border: "none", color: "#fff" }} color='info'><FontAwesomeIcon icon={faEdit} /></button>} </h5>
                <TabelaEnderecos
                    ficha = {setupVariavel?.requerAnaliseGeradorLocalidade}
                    enderecos={geradorFicha.localidades}
                    paging={false}
                    integracaoCadastros={integracaoCadastros}
                    visualizarAnaliseLocalidade={visualizarAnaliseLocalidade}
                />
            </div>


            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
            </h5>
            <Row>
                {gerador?.documentos.map((documento, index) => (
                    <Col lg={3} key={index} className="mb-3">
                        <div className="card shadow h-100">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="d-flex flex-column align-items-center">
                                    <label htmlFor={`file-upload-${index}`} className="mb-3">
                                        <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                                    </label>
                                </div>

                                <div className="mb-3">
                                    <strong>{documento.identificacao || "Documento"}</strong>
                                </div>

                                <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                                    if (documento.arquivo.includes(".pdf"))
                                        window.open(documento.arquivo, "_blank")
                                    else
                                        abrirPDF(documento.arquivo);
                                }}>
                                    <FontAwesomeIcon icon={faEye} /> Visualizar
                                </button>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            {session &&
                session.acesso.sigla != "GG" &&
                cadastroExternoGerador == false &&
                <div>
                    <h5 style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary fw-normal d-flex justify-content-between align-items-center'>
                        <span><FontAwesomeIcon icon={faFileSignature} className={"me-3"} />Inscrições municipais</span>
                        {editEnderecos && <button
                            onClick={editEnderecos}
                            style={{ backgroundColor: "transparent", border: "none", color: "#fff" }}
                            color='info'><FontAwesomeIcon icon={faEdit} />
                        </button>}
                    </h5>
                    <TabelaInscricoesMunicipais
                        inscricoesMunicipais={geradorFicha.inscricaoMunicipais}
                        paging={false}
                    />
                </div>
            }

            {session &&
                <div>
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'>
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Contratos</span>
                        {editContratos && <button
                            onClick={editContratos}
                            style={{ backgroundColor: "transparent", border: "none", color: "#fff" }}>
                            <FontAwesomeIcon icon={faEdit} />
                        </button>}
                    </h5>
                    {geradorFicha.prazos && geradorFicha.prazos.length > 0 &&
                        <>
                            <h5>Prazos para regularização de contrato por modalidade</h5>
                            <Row>
                                {geradorFicha.prazos.map(value => {
                                    return (
                                        <Col md="12" lg="12">
                                            <span className='fw-bold'>{value.modalidadeColeta}: </span> <span className={
                                                value.status == "dentroDoPrazo"
                                                    ? "text-success"
                                                    : value.status == "50DoPrazo"
                                                        ? "text-warning"
                                                        : "text-danger"
                                            }>{moment(value.prazoRegularizacao).format("DD/MM/YYYY HH:mm:SS")}</span>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </>
                    }
                    {cadastroExternoGerador == false &&
                        geradorFicha.localidades.map(value => {
                            return (
                                <div>
                                    <h5
                                        className='mt-4'
                                    >
                                        <FontAwesomeIcon icon={faMapMarkerAlt} /> {value.logradouro}, {value.numero}, {value.bairro}{value.complemento ? ` - ${value.complemento}` : ""}
                                    </h5>
                                    <TabelaContratos
                                        ficha
                                        paging={false}
                                        qrCode={(item, itemKey) => {
                                            if (item.tag) {
                                                return (<td className='text-center d-flex align-items-center justify-content-center' >
                                                    <Button
                                                        className={" d-flex align-items-center justify-content-center"}
                                                        style={{ borderRadius: "100%", width: "35px", height: "35px" }}
                                                        color='info text-light'
                                                        onClick={() => onClickQrCode(item, value)}
                                                        id={`btnRemover${itemKey}`}
                                                    >
                                                        <FontAwesomeIcon icon={faQrcode} />
                                                    </Button>

                                                </td>)
                                            } else {
                                                return <td></td>
                                            }
                                        }}
                                        items={value.contratos && value.contratos.length > 0 ? [...value.contratos] : []}
                                    />
                                </div>
                            );
                        })
                    }

                </div>

            }
            {
                modulo == "Fiscal" &&
                <div>
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'>
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Vistorias</span>
                    </h5>
                    {
                        geradorFicha.vistorias.map(value => {
                            if (!isNaN(new Date(value.dataAgendamento)))
                                value.dataAgendamento = moment(value.dataAgendamento).format("DD/MM/YYYY HH:mm")
                            return (
                                <div>
                                    <h5 className='mt-4'><FontAwesomeIcon icon={faMapMarkerAlt} /> {value.logradouro}, {value.numero}, {value.bairro}{value.complemento ? ` - ${value.complemento}` : ""}</h5>
                                    <TabelaListagemFichas headers={headersVistorias} items={[value]} visualizar={(value) => setVistoria(value.id)} />
                                </div>
                            );
                        })
                    }

                </div>
            }

        </div>
    );
}